import React, { useState } from 'react';
import './CarteiraHub.css';
import CarteiraDashboard from './CarteiraDashboard';
import CDRDashboard from './CDRDashboard';

const STORAGE_KEY = 'fatcat-selected-portfolio';

export default function CarteiraHub() {
  const [portfolio, setPortfolio] = useState(() => {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return saved === 'cdr' ? 'cdr' : 'swing';
  });

  const selectPortfolio = event => {
    const next = event.target.value;
    setPortfolio(next);
    window.localStorage.setItem(STORAGE_KEY, next);
  };

  return (
    <div className="carteira-hub">
      <header className="carteira-hub-header">
        <div className="carteira-hub-title">
          <span className="carteira-hub-eyebrow">CENTRAL DE CARTEIRAS</span>
          <h1>Carteira</h1>
        </div>
        <label className="carteira-hub-selector">
          <span>Carteira ativa</span>
          <select value={portfolio} onChange={selectPortfolio} aria-label="Selecionar carteira">
            <option value="swing">Swing Trader</option>
            <option value="cdr">CDR — The Wheel</option>
          </select>
        </label>
      </header>
      <div className="carteira-hub-content">
        {portfolio === 'cdr' ? <CDRDashboard /> : <CarteiraDashboard />}
      </div>
    </div>
  );
}